/**
 * Alert.
 */

const now = new Date();
const alert = document.querySelector('.tag-alert');

if (alert) {
	const id = alert.id;

	// Check for cookie.
	const cookie = document.cookie.split(';').find((row) => row.trim().startsWith(`${id}=`));

	// If cookie is set, alert has been dismissed.
	if (cookie) {
		console.log('dismissing alert due to cookie');
		alert.style.display = 'none';
	}
	else {
		// Check for startOn & endOn dates.
		// NOTE: PHP timestamps are in seconds, JS timestamps are in milliseconds.
		const startOn = alert.dataset.startOn ? new Date(alert.dataset.startOn * 1000) : null;
		const endOn = alert.dataset.endOn ? new Date(alert.dataset.endOn * 1000) : null;

		// If within date range and dialog is not open, open it.
		if (((startOn && now > startOn) || (endOn && now < endOn)) && !alert.open) {
			alert.show();
		}

		// If alert is not within the date range, hide it.
		if (((startOn && now < startOn) || (endOn && now > endOn)) && alert.open) {
			//alert.close();
			alert.style.display = 'none';
		}
	}

	const dismissExpires = alert.dataset.dismissExpires ? datePlusDays(alert.dataset.dismissExpires) : datePlusDays();

	// When alert dialog is dismissed, set a cookie with the expiration date.

	alert.addEventListener('close', () => {
		document.cookie = `${id}=${dismissExpires.getTime()}; expires=${dismissExpires.toUTCString()}; SameSite=lax; path=/`;
	});
}

function datePlusDays(days = 7) {
	const date = new Date();
	date.setDate(date.getDate() + days);
	return date;
}
